import React, { useState, useEffect } from 'react';

// Pixel-art dino - Same as Timer page, AQUAMARINE
// Values: 0=empty, 1=dino color, 2=white (eye)
const Dino = ({ frame }) => {
  const pixels1 = [
    [0,0,0,0,0,0,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,2,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,0,0,0],
    [0,0,0,1,0,1,1,1,1,1,0,0],
    [0,0,1,1,1,1,1,1,1,1,0,0],
    [0,1,1,1,1,1,1,1,1,0,0,0],
    [1,1,1,1,1,1,1,1,0,0,0,0],
    [0,1,1,1,1,1,1,1,0,0,0,0],
    [0,0,1,1,1,1,1,0,0,0,0,0],
    [0,0,0,1,1,0,1,1,0,0,0,0],
    [0,0,0,1,0,0,0,1,0,0,0,0],
    [0,0,0,1,1,0,0,0,0,0,0,0],
  ];
  
  const pixels2 = [
    [0,0,0,0,0,0,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,2,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,0,0,0],
    [0,0,0,1,0,1,1,1,1,1,0,0],
    [0,0,1,1,1,1,1,1,1,1,0,0],
    [0,1,1,1,1,1,1,1,1,0,0,0],
    [1,1,1,1,1,1,1,1,0,0,0,0],
    [0,1,1,1,1,1,1,1,0,0,0,0],
    [0,0,1,1,1,1,1,0,0,0,0,0],
    [0,0,0,1,0,1,0,0,0,0,0,0],
    [0,0,0,1,0,1,0,0,0,0,0,0],
    [0,0,1,1,0,1,1,0,0,0,0,0],
  ];
  
  const pixels = frame === 0 ? pixels1 : pixels2;
  const colors = { 1: '#00E5CC', 2: '#FFFFFF' };
  
  return (
    <div 
      className="relative" 
      style={{ width: '52px', height: '56px' }}
    >
      {pixels.map((row, y) => 
        row.map((pixel, x) => 
          pixel > 0 && (
            <div
              key={`${x}-${y}`}
              className="absolute"
              style={{
                left: `${x * 4}px`,
                top: `${y * 4}px`,
                width: '4px',
                height: '4px',
                backgroundColor: colors[pixel],
              }}
            />
          )
        )
      )}
    </div>
  );
};

// Pixel-art llama - Same as Timer page, DEEP PURPLE
const Llama = () => {
  const pixels = [
    [0,0,0,1,0,1,0,0],
    [0,0,0,1,1,1,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,1,1,1,1,0,0],
    [0,1,1,1,1,1,1,0],
    [0,1,1,1,1,1,1,0],
    [0,0,1,1,1,1,0,0],
    [0,0,1,0,0,1,0,0],
    [0,0,1,0,0,1,0,0],
    [0,0,1,0,0,1,0,0],
  ];
  
  return (
    <div className="relative" style={{ width: '32px', height: '48px' }}>
      {pixels.map((row, y) => 
        row.map((pixel, x) => 
          pixel === 1 && (
            <div
              key={`${x}-${y}`}
              className="absolute"
              style={{
                left: `${x * 4}px`,
                top: `${y * 4}px`,
                width: '4px',
                height: '4px',
                backgroundColor: '#7C3AED',
              }}
            />
          )
        )
      )}
    </div>
  );
};

// Main component
export const LoadingDino = ({ message = "Loading 3,400+ phrases..." }) => {
  const [legFrame, setLegFrame] = useState(0);
  const [obstacleX, setObstacleX] = useState(400);
  const [playerHeight, setPlayerHeight] = useState(0);
  
  // Leg animation
  useEffect(() => {
    const t = setInterval(() => setLegFrame(f => (f + 1) % 2), 150);
    return () => clearInterval(t);
  }, []);
  
  // Main game loop - FINAL FIX: Longer jump, triggered later
  useEffect(() => {
    let posX = 400;
    let isJumping = false;
    let jumpTime = 0;
    const JUMP_DURATION = 700; // Longer jump
    const JUMP_HEIGHT = 95; // Taller jump
    const FRAME_TIME = 20;
    const LLAMA_SPEED = 4;
    
    const gameLoop = setInterval(() => {
      posX -= LLAMA_SPEED;
      
      if (posX < -60) {
        posX = 420;
        isJumping = false;
        jumpTime = 0;
      }
      
      setObstacleX(posX);
      
      // FINAL CALCULATION:
      // Dino left edge at x=30, width ~52px
      // Llama width ~32px
      // Collision zone: llama left edge between x=30 and x=82
      // Jump duration 700ms at 20ms/frame = 35 frames
      // Peak at frame 17-18 (halfway)
      // Llama moves 4px per frame, so in 17 frames llama moves 68px
      // To have llama at x=55 (middle of collision zone) at peak,
      // start jump when llama is at x = 55 + 68 = 123
      
      if (!isJumping && posX <= 130 && posX > 110) {
        isJumping = true;
        jumpTime = 0;
      }
      
      if (isJumping) {
        jumpTime += FRAME_TIME;
        const progress = Math.min(jumpTime / JUMP_DURATION, 1);
        const height = Math.sin(progress * Math.PI) * JUMP_HEIGHT;
        setPlayerHeight(height);
        
        if (progress >= 1) {
          isJumping = false;
          jumpTime = 0;
          setPlayerHeight(0);
        }
      }
    }, FRAME_TIME);
    
    return () => clearInterval(gameLoop);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center py-12 space-y-6">
      <div className="relative bg-white rounded-xl border-2 border-gray-200" style={{ width: '400px', height: '160px', overflow: 'hidden' }}>
        {/* Dino - fixed on left side, jumps up */}
        <div style={{ 
          position: 'absolute', 
          left: '30px', 
          bottom: `${45 + playerHeight}px`, 
          zIndex: playerHeight > 10 ? 20 : 5,
        }}>
          <Dino frame={legFrame} />
        </div>
        
        {/* Llama - moves from right to left */}
        <div style={{ 
          position: 'absolute', 
          left: `${obstacleX}px`, 
          bottom: '45px', 
          zIndex: 10 
        }}>
          <Llama />
        </div>
        
        {/* Ground line */}
        <div style={{ 
          position: 'absolute', 
          bottom: '40px', 
          left: '10px', 
          right: '10px', 
          height: '3px', 
          backgroundColor: '#D1D5DB',
          borderRadius: '2px'
        }} />
      </div>
      
      <div className="text-center space-y-3">
        <p className="text-lg font-medium text-foreground">{message}</p>
        <div className="flex items-center justify-center space-x-1.5">
          <span className="w-2.5 h-2.5 bg-[#00E5CC] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2.5 h-2.5 bg-[#00E5CC] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2.5 h-2.5 bg-[#00E5CC] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingDino;
